import { SubTitle } from '../styles'

import { config } from './config'
import { Title, ReportingtImage, Wrapper } from './styles'

const {
  monitoring: { titleMonitoring, subtitleMonitoring },
  reporting: { titleReporting, subtitleReporting },
  reportingImage,
} = config

export function Monitoring() {
  return (
    <Wrapper>
      <Title as="h3">{titleMonitoring}</Title>
      <SubTitle>{subtitleMonitoring}</SubTitle>
      <Title as="h3">{titleReporting}</Title>
      <SubTitle>{subtitleReporting}</SubTitle>
      {reportingImage && <ReportingtImage {...reportingImage} />}
    </Wrapper>
  )
}
